// SIMPLE TEST PAGE

export default function InvoicesSimple() {
  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#ffff99',
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{
        fontSize: '36px',
        color: '#ff0000',
        marginBottom: '20px',
        textAlign: 'center'
      }}>
        🔥 WORKING TEST PAGE 🔥
      </h1>
      
      <div style={{
        backgroundColor: '#00ff00',
        padding: '20px',
        border: '5px solid #ff0000',
        marginBottom: '20px'
      }}>
        <h2>SUCCESS! Zmeny sa zobrazujú!</h2>
        <p>Ak vidíte túto stránku, routing funguje.</p>
        <p>Problém bol pravdepodobne v React komponentoch alebo CSS.</p>
      </div>

      <div style={{
        backgroundColor: '#ff9999',
        padding: '15px',
        border: '3px solid #000'
      }}>
        <p><strong>Toto je /invoices-simple stránka</strong></p>
        <p>Teraz môžeme opraviť pôvodnú faktúry stránku.</p>
      </div>
    </div>
  );
}